import React from 'react';

import { Tooltip } from '@repo/ui/components/Tooltip';

import {
  Tab,
  TabLabel,
  TabLabelDescription,
  TabsBox,
  TabsWrapper,
} from './styles';
import { TabsProps } from './types';

const NewTabs: React.FC<TabsProps> = ({ tabsInfo, onTabClick }) => {
  return (
    <TabsWrapper>
      <TabsBox>
        {tabsInfo.map((tab) => {
          return (
            <Tooltip key={tab.id} text={tab.tooltipText || tab.label}>
              <Tab
                aria-selected={tab.isActive}
                data-testid={`tab-${tab.id}`}
                isActive={tab.isActive}
                isPlanIntervalTab={tab.isPlanIntervalTab}
                onClick={(): void => {
                  onTabClick(tab.id);
                }}
              >
                {tab.elementBefore && <tab.elementBefore />}
                <TabLabel isActive={tab.isActive}>{tab.label}</TabLabel>
                <TabLabelDescription>
                  {tab.labelDescription}
                </TabLabelDescription>
                {tab.elementAfter && <tab.elementAfter />}
              </Tab>
            </Tooltip>
          );
        })}
      </TabsBox>
    </TabsWrapper>
  );
};

export default NewTabs;
